import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Amplify, { Auth } from 'aws-amplify';
import { Provider } from 'react-redux';

import App from './App';
import store from './redux/store';
import registerServiceWorker from './registerServiceWorker';
import config from './config';
import { setLoggedInUser } from './redux/actions/user';

import './index.css';

async function startApp() {
  Amplify.configure({
    Auth: {
      mandatorySignIn: true,
      region: config.cognito.REGION,
      userPoolId: config.cognito.USER_POOL_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      userPoolWebClientId: config.cognito.APP_CLIENT_ID
    },
    Storage: {
      region: config.s3.REGION,
      bucket: config.s3.BUCKET,
      identityPoolId: config.cognito.IDENTITY_POOL_ID
    },
    API: {
      endpoints: [
        {
          name: 'notes',
          endpoint: config.apiGateway.URL,
          region: config.apiGateway.REGION
        }
      ]
    }
  });

  try {
    if (await Auth.currentSession()) {
      await store.dispatch(setLoggedInUser());
    }
  } catch (e) {
    // no logged in user
  }

  ReactDOM.render(
    <Router>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>,
    document.getElementById('root')
  );

  registerServiceWorker();
}

startApp();



// WEBPACK FOOTER //
// ./src/index.js